module.exports = __webpack_public_path__ + "img/report-open.e168daac.png";